import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
import { costs, faqs } from '../data/copy';
import { purchases } from '../data/testimonials';
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-21" data-mp="3pmbvpognut5j">
        <div className="mx-auto max-w-3xl text-center" data-id="element-22" data-mp="3brj802qma6nv">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" aria-hidden="true" data-id="element-23" data-mp="3gjkj3lc1trcb" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-24" data-mp="31v6gnbijo4wa">
            GARANTÍA 14 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-25" data-mp="36usrxfetbb2g">
            <p className="text-slate-300" data-id="element-26" data-mp="2svay2lmnt7m8">
              Capturás. Organizás. Gestionás lo que llega con una rutina simple.
            </p>
            <p className="mt-4 text-slate-300" data-id="element-27" data-mp="2wxxu6yqd5ep8">
              Si en 14 días sentís que no lográs ordenar la información que recibís, te devolvemos el
              100%.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-light sm:text-4xl" data-id="element-28" data-mp="2asgvlumrqpez">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-29" data-mp="2kr644wsryxik">sin formularios, sin drama.</p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-30" data-mp="1x12bfkh4ki6c">Tasa de devoluciones: menos del 1%.</p>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-31" data-mp="1s30j08xt76i7">
        <div className="mx-auto max-w-3xl" data-id="element-32" data-mp="1s0eb2870aozg">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-33" data-mp="26s6pmhyz7z04">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-34" data-mp="21z3vo8qaenje">
            {faqs.map((faq, index) => {
            const panelId = `faq-panel-${index}`;
            const isOpen = open === index;
            return <div key={faq.question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-35" data-mp="19b80x9ka35p9" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-36" data-mp="1yxsl4f8a2z44">
                    <span data-id="element-37" data-mp="2cr0di946nymv">{faq.question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-38" data-mp="2cpysbbtgdvrf" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-39" data-mp="1k34h75ij08qm">
                    {isOpen && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.2,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-40" data-mp="1p1fszlsdstbh">
                        <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-41" data-mp="tral6ckwz167">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-42" data-mp="b1uef7imychc">
      <div className="mx-auto max-w-4xl" data-id="element-43" data-mp="b018xvjrdyax">
        <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-44" data-mp="62huauj5fjig">
          ⚖️ ¿CUÁNTO CUESTA NO TENER EL SISTEMA?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-45" data-mp="160xlbxvvwtr">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-[#1a4a2e] border-l-[#2d6b45] bg-[#0d2f1e] px-5 py-4 font-medium last:border-b-0" data-id="element-46" data-mp="3scc07cijl5n7">
              <span className="mr-2 text-red-400" aria-hidden="true" data-id="element-47" data-mp="1qimkqvd5bpo4">
                ×
              </span>
              {item}
            </p>)}
        </div>
        
        
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => window.clearInterval(timer);
  }, []);
  return <>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-48" data-mp="1klcb3x6r176u">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-49" data-mp="15w7qk9cheqvk">
          🎯 SISTEMA INFORMACIÓN BAJO CONTROL™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-50" data-mp="wuqdkzudf5b3">
          El protocolo de gestión de información para madres argentinas que acompañan a hijos con
          epilepsia refractaria.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-slate-500" data-id="element-51" data-mp="i9m4cbfehowr">
          Tu información no es caos. Es una pila sin orden.
        </p>

        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-52" data-mp="r8g2w7cakpcy">
          <a className="transition-colors duration-150 ease-out hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-53" data-mp="m81w0smfflgi">
            📧 soportebiomalivido@gmail.com
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-light" href="https://www.instagram.com/biomalivido/" target="_blank" rel="noreferrer" data-id="element-54" data-mp="w82iuoji8jpg">
            📲 @biomalivido
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-light" href="https://www.biomalivido.com" target="_blank" rel="noreferrer" data-id="element-55" data-mp="15y58qfvbxhjk">
            🌐 biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-slate-600" data-id="element-56" data-mp="1ez3izfwd2lal">
          © SISTEMA INFORMACIÓN BAJO CONTROL™ 2026 — Todos los derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-57" data-mp="glg0n6d5bd7f">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-58" data-mp="gmhd9f9t87r9">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-59" data-mp="108dpfhp5odgc">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-60" data-mp="149fq82yq0xkf" />
              Acceso confirmado
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-61" data-mp="362wx34f11ue4">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-slate-300" data-id="element-62" data-mp="3b31ecwnret5e">adquirió Sistema Información Bajo Control™</p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-63" data-mp="33jip48nxa3od">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}